module.exports = __webpack_public_path__ + "app/modals/set-arrow-board-display.view.html";